import {getDamBaseUrl} from '../../custom-hooks/use-dam-image'

/**
 * This function takes a parsed json object and returns a formatted array of objects. The format is the same as the keyFeature uses
 * @param {Array} keyFeatures
 * @returns {Array|null}
 */

export const formatCards = (keyFeatures) => {
    const baseUrl = getDamBaseUrl()

    if (!keyFeatures) return []

    let formattedCards = keyFeatures?.map((feature) => ({
        uid: feature.code,
        image: {
            url: `${baseUrl}/${feature.imageLink}`,
        },
        header_copy: feature.title,
        body_copy: feature.description,
    }))
    return formattedCards
}
